// extracted by mini-css-extract-plugin
module.exports = {"favicon":"index_favicon__2Ruxt","empty":"index_empty__1mTPO","loading":"index_loading__oJn1R","faviconWrap":"index_faviconWrap__2m2NR"};